export const GET_EMPLOYEE_INTERVIEWS_SUCCESS = 'GET_EMPLOYEE_INTERVIEWS_SUCCESS';
export const SELECT_EMPLOYEE_INTERVIEW = 'SELECT_EMPLOYEE_INTERVIEW';
export const SET_SELECTED_EMPLOYEE_INTERVIEW_FIELD = 'SET_SELECTED_EMPLOYEE_INTERVIEW_FIELD';
export const CLEAN_SELECTED_EMPLOYEE_INTERVIEW = 'CLEAN_SELECTED_EMPLOYEE_INTERVIEW';
export const FETCH_ENTITY_DETAILS_SUCCESS = 'FETCH_ENTITY_DETAILS_SUCCESS';
export const SELECT_ENTITY_DETAIL_CRUD = 'SELECT_ENTITY_DETAIL_CRUD';
export const SET_SELECTED_ENTITY_DETAIL_FIELD = 'SET_SELECTED_ENTITY_DETAIL_FIELD';
export const FETCH_ENTITY_DETAIL_TYPES_SUCCESS = 'FETCH_ENTITY_DETAIL_TYPES_SUCCESS';
